export default [
  {
    label: 'Unpaid',
    value: 'created',
  },
  {
    label: 'Paid',
    value: 'paid',
  },
  {
    label: 'Cancelled',
    value: 'cancel',
  },
];
